import Vue from 'vue';
import __CFG from '@/conf/config.json';

// Reaktywny, globalny store parametrow wniosku.
// Zamiast propagowac wartosci po komponentach przez bus ('values_set'),
// kazdy komponent czyta/pisze te same pola przez computed get/set w common.js.
export default new Vue({
  data: function() {
    return {
      loanAmount: __CFG.default_amount || 1000,
      loanTenor: __CFG.default_tenor || 2,
      tenorSign: __CFG.tenor_sign || 'm',
      total: '',
      interest: '',
      commission: '',
      service: '',
      insurance: '',
      rrso: '',
      dailyInterest: '',
      finishDate: ''
    };
  }
});



// WEBPACK FOOTER //
// ./src/stores/loanStore.js